import React from 'react';
import { Message, Segment } from 'semantic-ui-react';

import Button from '../../../components/Button';

type Props = {
  openKycLink: () => void;
  loadActivationStatus: () => void;
  activationLoading: boolean;
};

const KycBanner: React.FC<Props> = ({ openKycLink, loadActivationStatus, activationLoading }) => {
  return (
    <Segment>
      <Message info style={{ marginBottom: 0 }}>
        <Message.Header>Biometria pendente na Pagar.me</Message.Header>
        <p>
          Enquanto a prova de vida não for concluída, não é possível criar novas cobranças.
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button type="button" text="Abrir biometria" onClick={openKycLink} />
          <Button
            type="button"
            text="Atualizar status"
            light
            onClick={loadActivationStatus}
            loading={activationLoading}
            disabled={activationLoading}
          />
        </div>
      </Message>
    </Segment>
  );
};

export default KycBanner;

